'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InterpolateLinks;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInterpolateComponent = require('react-interpolate-component');

var _reactInterpolateComponent2 = _interopRequireDefault(_reactInterpolateComponent);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'link': 'ccl-c168a4563db7cc63'
};

// eslint-disable-next-line react/prop-types

var defaultRender = function defaultRender(_ref, links) {
  var linkText = _ref.linkText,
      linkId = _ref.linkId;

  var linkUrl = links[linkId];

  return _react2.default.createElement(
    'a',
    { href: linkUrl, className: styles.link },
    linkText
  );
};

defaultRender.displayName = 'defaultRender';
/**
 * A component for safely interpolating i18n text with links. See
 * [here](https://github.com/deliveroo/rfc/blob/master/rfcs/0007-i18n-link-interpolation-syntax.md)
 * for further details.
 */
function InterpolateLinks(_ref2) {
  var template = _ref2.template,
      links = _ref2.links,
      render = _ref2.render;

  var linkRegex = /(?:\[)(.+?)(?:\])(?:\(%\((.+?)\)s\))/g;
  var renderedLinks = {};

  var templateString = template.replace(linkRegex, function (_match, linkText, linkId) {
    renderedLinks[linkId] = render({ linkText: linkText, linkId: linkId }, links);

    return '%(' + linkId + ')s';
  });

  return _react2.default.createElement(_reactInterpolateComponent2.default, { format: templateString, 'with': renderedLinks });
}

InterpolateLinks.displayName = 'InterpolateLinks';
InterpolateLinks.propTypes = {
  /**
   * The string template to interpolate, using the placeholder syntax.
   */
  template: _propTypes2.default.string.isRequired,

  /**
   * The render method to replace placeholders with links.
   *
   * e.g. `({ linkText }) => <a href="/">{linkText}</a>`
   */
  render: _propTypes2.default.func,

  /**
   * An object containing link URLs, with corresponding link identifiers as
   * keys. Used when no
   *
   * e.g. { terms_link: '/terms' }
   */
  links: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.object, function (_ref3) {
    var render = _ref3.render;
    return typeof render === 'undefined';
  })
};

InterpolateLinks.defaultProps = {
  render: defaultRender,
  links: {}
};